import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ToastContext } from 'contexts';
import { useAsync } from 'helpers/hooks';
import { sendAccountConfirmationEmail } from 'helpers/auth';

export default () => {
  const { t } = useTranslation();
  const { triggerToast } = useContext(ToastContext);

  const [{ isLoading, isSuccess, isError }, execute] = useAsync(
    sendAccountConfirmationEmail,
    false
  );

  if (isError) {
    triggerToast({ message: t('generic_error') });
  }

  if (isSuccess) {
    triggerToast({
      message: t('login.send_confirm_email_success'),
      variant: 'success',
    });
  }

  return [isLoading, execute];
};
